import { useState, useEffect } from 'react';

export default function useLocalStorage(key, defaultValue) {

  console.log('defaultValue localStorage:', key);

  const [value, setValue] = useState(() => {
    try {
      const storedValue = typeof window !== 'undefined' ? localStorage.getItem(key) : null;
      return storedValue === null ? defaultValue : JSON.parse(storedValue);
    } catch (error) {
      console.error('Error reading localStorage:', error);
      return defaultValue;
    }
  });

  useEffect(() => {
    const listener = (e) => {
      if (typeof window !== 'undefined' && e.storageArea === localStorage && e.key === key) {
        setValue(e.newValue ? JSON.parse(e.newValue) : e.newValue);
      }
    };
    window.addEventListener('storage', listener);

    return () => {
      window.removeEventListener('storage', listener);
    };
  }, [key]);

  const setValueInLocalStorage = (newValue) => {
    try {
      setValue((currentValue) => {
        const result = typeof newValue === 'function' ? newValue(currentValue) : newValue;
        if (typeof window !== 'undefined') {
          localStorage.setItem(key, JSON.stringify(result));
        }
        return result;
      });
    } catch (error) {
      console.error('Error saving to localStorage:', error);
    }
  };

  return [value, setValueInLocalStorage];
}
